module.exports = __webpack_public_path__ + "static/media/RRG_Bismarck_Web.8aa10d17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/RRG_Bismarck_Web.jpg
// module id = 114
// module chunks = 0